<template>
  <DefaultField
    :field="currentField"
    :errors="errors"
    :show-help-text="showHelpText"
    :full-width-content="fullWidthContent"
  >
    <template #field>
      <input
        v-bind="extraAttributes"
        class="w-full form-control form-input form-input-bordered"
        dir="ltr"
        inputmode="tel"
        autocomplete="tel"
        @input="handleChange"
        :value="value"
        :id="currentField.uniqueKey"
        :dusk="field.attribute"
        :disabled="currentlyIsReadonly"
      />
    </template>
  </DefaultField>
</template>

<script>
import { DependentFormField, HandlesValidationErrors } from '@/mixins'
import { normalizePhoneNumber } from '../../utils/phoneNumber'

export default {
  mixins: [DependentFormField, HandlesValidationErrors],

  props: ['resourceName', 'resourceId', 'field'],

  methods: {
    setInitialValue() {
      this.value = this.field.value || ''
    },

    fill(formData) {
      formData.append(this.field.attribute, normalizePhoneNumber(this.value))
    },

    handleChange(event) {
      const normalized = normalizePhoneNumber(event.target.value)

      this.value = normalized
      event.target.value = normalized

      if (this.field) {
        this.emitFieldValueChange(this.fieldAttribute, normalized)
      }
    },
  },

  computed: {
    defaultAttributes() {
      return {
        type: 'text',
        placeholder: this.currentField.placeholder || this.field.name,
        class: this.errorClasses,
      }
    },

    extraAttributes() {
      return {
        ...this.defaultAttributes,
        ...this.currentField.extraAttributes,
      }
    },
  },
}
</script>
